import Vue from 'vue';
import Confirm from '@/components/common/Confirm/Confirm.vue';
import ConfirmPlugin from '@/components/common/Confirm/plugin';

Vue.component('Confirm', Confirm);
Vue.use(ConfirmPlugin);
